<div class="popover-creation-compte-pro">
  <div class="btn-close">
    <ion-icon slot="end" src="./assets/svg/close-popup.svg" (click)="closePopup()"></ion-icon>
  </div>
  <p class="typo-20-semibold-green">Le compte de {{prenom}} {{nom}} <br>
    a bien été créé.</p>
</div>
